import comp from "./AiQuestionGeneratorCustomInstruction";
export default comp;
